/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Publication product type enumeration.
 */
export type ProductKind = typeof ProductKind[keyof typeof ProductKind];


export const ProductKind = {
  ebook: 'ebook',
  audio: 'audio',
} as const;
